export function getQueryInterface(api) {
    return (
    // latest substrate (latest always first)
    api.query.voterBagsList ||
        // previous substrate
        api.query.bagsList ||
        // latest polkadot
        api.query.voterList);
}